import { Ref } from 'vue';
import { useFocus } from '@vueuse/core';

interface Params {
  input: Ref<HTMLInputElement | null | undefined>;
  list: Ref<HTMLDivElement[] | null | undefined>;
}

const useUpAndDownArrowNavigation = ({ input, list }: Params) => {
  const index = ref(-1);
  const suggestionBlurBlocked = ref(false);

  const { focused } = useFocus(input);

  const handleUpArrowPress = () => {
    if (index.value > -1 && list.value?.length) {
      if (index.value <= list.value.length - 1 && index.value) {
        index.value--;
      } else {
        index.value = list.value.length - 1;
      }
    } else {
      index.value = list.value?.length ? list.value.length - 1 : -1;
    }
    list.value?.[index.value]?.focus();
  };

  const handleDownArrowPress = () => {
    if (index.value > -1 && list.value?.length) {
      if (index.value < list.value.length - 1) {
        index.value++;
      } else {
        index.value = 0;
      }
    } else {
      index.value = 0;
    }
    list.value?.[index.value]?.focus();
  };

  const handleUpOrDownArrowPress = (e: KeyboardEvent) => {
    if (focused.value || index.value > -1) {
      if (e.key === 'ArrowDown') {
        e.preventDefault();
        suggestionBlurBlocked.value = true;
        handleDownArrowPress();
      } else if (e.key === 'ArrowUp') {
        e.preventDefault();
        suggestionBlurBlocked.value = true;
        handleUpArrowPress();
      } else if (e.key === 'Escape' && index.value > -1) {
        e.preventDefault();
        list.value?.[index.value].blur();
        index.value = -1;
      }
    }
  };

  onMounted(() => {
    document.addEventListener('keydown', (e: KeyboardEvent) => handleUpOrDownArrowPress(e));
  });

  watch(focused, newVal => {
    if (newVal) {
      index.value = -1;
    }
  });

  const handleButtonBlur = () => {
    if (suggestionBlurBlocked) suggestionBlurBlocked.value = false;
    else {
      index.value = -1;
    }
  };

  return { handleButtonBlur };
};

export default useUpAndDownArrowNavigation;
